/* Mon Chou refine — theme 3.73 (Claude, 2026-10-11)
   1. Search overlay: takes over the header search icons (.search-show) and shows
      a full-screen, minimal search with predictive results rendered by
      sections/mc-predictive-search.liquid (Shopify predictive search API).
   2. Letter picker: any product option whose values are all 1–2 characters
      (the Bogstav A–Z necklaces) becomes a compact 5-per-row grid with a search
      field, styled like the personaliser's emoji keyboard. The theme's own
      <select> stays in place and is driven with a normal change event, so the
      variant, price, image and add-to-cart all update exactly as before.
   Loaded (deferred) from snippets/search-bar.liquid. */
(function () {
  'use strict';
  if (window.__mcRefine) return;
  window.__mcRefine = true;

  var I18N = window.MC_I18N || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SEARCH_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 20 20"/></svg>';
  var CHEV_SVG = '<svg class="mc-lp__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function focusNoScroll(node) { try { node.focus({ preventScroll: true }); } catch (e) { node.focus(); } }

  /* ---------------------------------------------------------------- search */
  function initSearch() {
    var all = document.querySelectorAll('#mc-search');
    for (var i = 1; i < all.length; i++) all[i].parentNode.removeChild(all[i]);
    var el = all[0];
    if (!el) return;
    if (el.parentNode !== document.body) document.body.appendChild(el);

    var input = el.querySelector('.mc-search__input');
    var form = el.querySelector('.mc-search__form');
    var results = el.querySelector('[data-mc-results]');
    var popSlot = el.querySelector('[data-mc-popular-slot]');
    var isOpen = false, timer = null, ctrl = null, lastQ = '', popLoaded = false, returnFocus = null, cache = {};

    function open() {
      if (isOpen) return;
      isOpen = true;
      returnFocus = document.activeElement;
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('mc-search-lock');
      focusNoScroll(input); // synchronous, inside the tap, so iOS opens the keyboard
      loadPopular();
    }
    function close() {
      if (!isOpen) return;
      isOpen = false;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('mc-search-lock');
      input.blur();
      if (returnFocus && returnFocus.focus && returnFocus !== document.body) focusNoScroll(returnFocus);
    }
    window.mcSearch = { open: open, close: close };

    // Capture phase: runs before the theme's own listener on the icon, which never fires.
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('.search-show, [data-mc-search-open]') : null;
      if (!t || el.contains(t)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
    }, true);
    document.addEventListener('pointerover', function (e) {
      if (e.target && e.target.closest && e.target.closest('.search-show')) loadPopular();
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) { e.preventDefault(); close(); }
    });

    el.querySelector('[data-mc-close]').addEventListener('click', close);
    el.querySelector('[data-mc-clear]').addEventListener('click', function () {
      input.value = '';
      onInput();
      focusNoScroll(input);
    });
    input.addEventListener('input', onInput);
    form.addEventListener('submit', function (e) { if (!input.value.trim()) e.preventDefault(); });

    function onInput() {
      var q = input.value.trim();
      el.classList.toggle('has-value', input.value.length > 0);
      clearTimeout(timer);
      if (!q) {
        lastQ = '';
        if (ctrl) ctrl.abort();
        el.classList.remove('has-query', 'is-loading');
        results.innerHTML = '';
        return;
      }
      timer = setTimeout(function () { fetchResults(q); }, 170);
    }

    function fetchResults(q) {
      if (q === lastQ) return;
      lastQ = q;
      if (cache[q] != null) { render(cache[q]); return; }
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      el.classList.add('is-loading');
      var url = ROOT + 'search/suggest?q=' + encodeURIComponent(q) +
        '&' + encodeURIComponent('resources[type]') + '=product,collection,query,page' +
        '&' + encodeURIComponent('resources[limit]') + '=10' +
        '&' + encodeURIComponent('resources[limit_scope]') + '=each' +
        '&' + encodeURIComponent('resources[options][unavailable_products]') + '=last' +
        '&section_id=mc-predictive-search';
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var node = doc.querySelector('[data-mc-predictive]');
          var out = node ? node.innerHTML : '';
          cache[q] = out;
          if (q === lastQ) render(out);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          el.classList.remove('is-loading');
          lastQ = '';
        });
    }

    function render(html) {
      results.innerHTML = html;
      el.classList.add('has-query');
      el.classList.remove('is-loading');
    }

    function loadPopular() {
      if (popLoaded || !popSlot) return;
      popLoaded = true;
      fetch(ROOT + '?sections=mc-search-popular')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data && data['mc-search-popular'];
          if (!html) return hidePopular();
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var node = doc.querySelector('[data-mc-popular]');
          if (node && node.querySelector('.mc-card')) popSlot.innerHTML = node.innerHTML;
          else hidePopular();
        })
        .catch(hidePopular);
    }
    function hidePopular() {
      var block = popSlot && popSlot.closest('.mc-search__block');
      if (block) block.style.display = 'none';
    }
  }

  /* ---------------------------------------------------------- letter picker */
  var lpCount = 0;
  var FINE_POINTER = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function isLetterSelect(sel) {
    var opts = sel.options;
    if (!opts || opts.length < 10) return false;
    for (var i = 0; i < opts.length; i++) {
      var v = (opts[i].value || '').trim();
      if (!v || v.length > 2) return false;
    }
    return true;
  }

  function buildLetterPicker(sel) {
    sel.setAttribute('data-mc-lp', '1');
    var dd = sel.closest('.wetheme-dropdown');
    var anchor = dd || sel;
    var field = sel.closest('.product-option-select') || anchor.parentNode;
    var labelEl = dd && dd.querySelector('label');
    var label = labelEl ? labelEl.textContent.trim() : '';
    var id = 'mc-lp-' + (++lpCount);

    var wrap = document.createElement('div');
    wrap.className = 'mc-lp';
    wrap.setAttribute('data-open', '0');
    wrap.innerHTML =
      '<button type="button" class="mc-lp__trigger" aria-expanded="false" aria-controls="' + id + '">' +
        '<span class="mc-lp__label"></span><span class="mc-lp__value"></span>' + CHEV_SVG +
      '</button>' +
      '<div class="mc-lp__panel" id="' + id + '">' +
        '<div class="mc-lp__search">' + SEARCH_SVG +
          '<input class="mc-lp__input" type="text" autocomplete="off" autocorrect="off" autocapitalize="characters" spellcheck="false" maxlength="2" enterkeyhint="done">' +
        '</div>' +
        '<div class="mc-lp__grid" role="listbox"></div>' +
        '<p class="mc-lp__empty" hidden></p>' +
      '</div>';

    var trigger = wrap.querySelector('.mc-lp__trigger');
    var valueEl = wrap.querySelector('.mc-lp__value');
    var input = wrap.querySelector('.mc-lp__input');
    var grid = wrap.querySelector('.mc-lp__grid');
    var empty = wrap.querySelector('.mc-lp__empty');

    wrap.querySelector('.mc-lp__label').textContent = label;
    input.placeholder = I18N.letterSearch || '';
    input.setAttribute('aria-label', I18N.letterSearch || label);
    grid.setAttribute('aria-label', label);
    empty.textContent = I18N.letterNone || '';

    each(sel.options, function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mc-lp__cell';
      b.setAttribute('role', 'option');
      b.setAttribute('data-v', o.value);
      b.textContent = o.value;
      var li = dd && dd.querySelector('li[value="' + (window.CSS && CSS.escape ? CSS.escape(o.value) : o.value) + '"]');
      if (li && /disabled|unavailable|sold/i.test(li.className)) b.classList.add('is-soldout');
      if (o.disabled) { b.disabled = true; b.classList.add('is-soldout'); }
      grid.appendChild(b);
    });

    field.classList.add('mc-lp-on');
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);

    function isOpen() { return wrap.getAttribute('data-open') === '1'; }
    function sync() {
      valueEl.textContent = sel.value;
      each(grid.children, function (c) {
        c.setAttribute('aria-selected', c.getAttribute('data-v') === sel.value ? 'true' : 'false');
      });
    }
    function updateEnd() {
      grid.classList.toggle('is-end', grid.scrollTop + grid.clientHeight >= grid.scrollHeight - 2);
    }
    function filter(q) {
      q = (q || '').trim().toUpperCase();
      var shown = 0;
      each(grid.children, function (c) {
        var ok = !q || c.getAttribute('data-v').toUpperCase().indexOf(q) === 0;
        c.hidden = !ok;
        if (ok) shown++;
      });
      empty.hidden = shown > 0;
      grid.scrollTop = 0;
      updateEnd();
    }
    function setOpen(v) {
      wrap.setAttribute('data-open', v ? '1' : '0');
      trigger.setAttribute('aria-expanded', v ? 'true' : 'false');
      if (!v) return;
      input.value = '';
      filter('');
      var cur = grid.querySelector('[aria-selected="true"]');
      if (cur) grid.scrollTop = Math.max(0, cur.offsetTop - grid.clientHeight / 2 + cur.offsetHeight / 2);
      updateEnd();
    }
    function choose(v) {
      if (sel.value !== v) {
        sel.value = v;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sync();
      setTimeout(function () { setOpen(false); }, 170);
    }

    trigger.addEventListener('click', function () {
      var next = !isOpen();
      setOpen(next);
      if (next && FINE_POINTER) focusNoScroll(input); // no auto-keyboard on phones
    });
    grid.addEventListener('click', function (e) {
      var c = e.target.closest('.mc-lp__cell');
      if (c && !c.disabled) choose(c.getAttribute('data-v'));
    });
    grid.addEventListener('scroll', updateEnd, { passive: true });
    input.addEventListener('input', function () { filter(input.value); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault(); // never submit the add-to-cart form from here
        var first = grid.querySelector('.mc-lp__cell:not([hidden]):not([disabled])');
        if (first) choose(first.getAttribute('data-v'));
      } else if (e.key === 'Escape') {
        setOpen(false);
        focusNoScroll(trigger);
      }
    });
    document.addEventListener('click', function (e) {
      if (isOpen() && !wrap.contains(e.target)) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) setOpen(false);
    });
    sel.addEventListener('change', sync);
    sync();
  }

  function initLetterPickers(scope, tries) {
    tries = tries || 0;
    var waiting = false;
    each((scope || document).querySelectorAll('select[id^="SingleOptionSelector-"]'), function (sel) {
      if (sel.getAttribute('data-mc-lp') || !isLetterSelect(sel)) return;
      // The theme builds its dropdown around the select after load; wait for it briefly.
      if (!sel.closest('.wetheme-dropdown') && tries < 20) { waiting = true; return; }
      buildLetterPicker(sel);
    });
    if (waiting) setTimeout(function () { initLetterPickers(scope, tries + 1); }, 150);
  }

  function boot() {
    initSearch();
    initLetterPickers(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { initLetterPickers(e.target); });
})();
/* 3.81 (Claude, 2026-10-18): collection cards - the product name turns black
   the moment a product is clicked/tapped (styled in mc-refine.css). On
   'click', not pointerdown, so a swipe through the card's image slider or a
   page scroll that starts on a card never flashes it. Cleared again when the
   page is restored from the back/forward cache. */
(function () {
  if (window.__mcCardPress) return;
  window.__mcCardPress = true;
  document.addEventListener('click', function (e) {
    if (!document.body || !document.body.classList.contains('template-collection')) return;
    var a = e.target && e.target.closest ? e.target.closest('article.indiv-product a[href*="/products/"]') : null;
    if (!a) return;
    var card = a.closest('article.indiv-product');
    if (card) card.classList.add('mc-pressed');
  }, true);
  window.addEventListener('pageshow', function () {
    var on = document.querySelectorAll('article.indiv-product.mc-pressed');
    for (var i = 0; i < on.length; i++) on[i].classList.remove('mc-pressed');
  });
})();
